module.exports = __webpack_public_path__ + "img/顺时针旋转90度.117ec26a.svg";